export default __webpack_public_path__ + "static/media/sketch-2.796fa660.svg";